import React from 'react';
import { createRoot } from 'react-dom/client';
import Animation from './animation';

export function renderAnimation(element, props = {}) {
  if (!element) {
    throw new Error('DOM element is required for animation');
  }
  
  const root = createRoot(element);
  root.render(<Animation {...props} />);
  
  // Return unmount function
  return () => root.unmount();
}

export default {
  renderAnimation
};